export function isAndroid(): boolean {
  return /android/i.test(navigator.userAgent)
}

export function isIOS(): boolean {
  return /iphone|ipad|ipod/i.test(navigator.userAgent)
}
